/*****
 * Created with WebStorm.
 * Date : 2018/1/24.
 * Author : Ztr.
 * Func : ..
 ******/
const getters = {
    uid: state => state.user.uid,     //用户id
    token: state => state.user.token, //用户令牌
    userInfo: state =>state.user.userInfo,//用户所有信息
    openId: state =>state.user.openId,//用户openId
    hospitalInfo: state =>state.user.hospitalInfo,//医院相关信息
    menu: state =>state.power.menu,//菜单列表
    commonData: state =>state.power.commonData,//平台数据信息
    routers: state =>state.power.routers, //路由表
    platform: state => state.user.platform,
    platId: state => state.user.platId,
    singleHospital: state =>state.user.singleHospital, //医院id
    searchKey: state => state.counselor.searchKey, //医生列表医院、科室搜索
    initHosp: state => state.counselor.initHosp,
    showBall: state => state.power.showBall,
    firstLog: state => state.counselor.firstLog
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js